import { FC } from "react";
import { useCountdown } from "shared/model";
import { formatTimeLeft } from "./formatTimeLeft";

interface Props {
  endsAt: string;
  className?: string;
}

// Отсчёт по ends_at: клиентских часов хватает для точности до секунд.
export const RaffleTimer: FC<Props> = ({ endsAt, className }) => {
  const secondsLeft = useCountdown(Date.parse(endsAt));
  return (
    <span className={className}>
      {secondsLeft > 0 ? formatTimeLeft(secondsLeft) : "Ended"}
    </span>
  );
};
